import { render } from "./WmsApprovalIn.vue?vue&type=template&id=6055831e&scoped=true"
import script from "./WmsApprovalIn.vue?vue&type=script&lang=js"
export * from "./WmsApprovalIn.vue?vue&type=script&lang=js"

import "./WmsApprovalIn.vue?vue&type=style&index=0&id=6055831e&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6055831e"]])

export default __exports__